const wwoAbilityRouter = {
  path: 'access',
  name: '',
  redirect: 'access/introduce',
  component: () => import('@/apps/open/views/fileCenter/components/FileRouter.vue'),
  meta: {
    title: ''
  },
  children: [
    {
      path: '/docs/wwo/access-know',
      name: '',
      component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
      meta: { title: '接入须知', mdfilepath: '/fileability/onlineediting/AccessKnow.md', aimtilelist: ['产品介绍', '产品流程', '支持格式'] }
    },
    {
      path: 'file-access-url',
      name: '',
      component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
      meta: { title: '接入方式', mdfilepath: '/fileability/onlineediting/FileAccessUrl.md', aimtilelist: ['产品介绍', '产品流程', '支持格式'] }
    },
    {
      path: 'api-list',
      name: '',
      component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
      meta: { title: '回调API标准', mdfilepath: '/fileability/onlineediting/ApiList.md', aimtilelist: ['接口目录'] }
    },
    {
      path: 'jssdk-import',
      name: '',
      component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
      meta: { title: 'JsSDK定制', mdfilepath: '/fileability/onlineediting/JsSdkImport.md', aimtilelist: ['概述', 'JSSDK 使用', '高级API'] }
    },
    {
      path: 'sdk-demo',
      name: '',
      component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
      meta: { title: 'SDK&DEMO', mdfilepath: '/fileability/onlineediting/Sdk&Demo.md', aimtilelist: ['接入须知', '资源下载', 'DEMO试用'] }
    },
    {
      path: 'signature',
      name: '',
      component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
      meta: { title: '签名说明', mdfilepath: '/fileability/onlineediting/Signature.md', aimtilelist: ['签名说明'] }
    },
    {
      path: 'error-code',
      name: '',
      component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
      meta: { title: '常见错误码', mdfilepath: '/returncode/WwoCode.md', aimtilelist: ['错误处理', '错误码', '错误信息'] }
    },
    {
      path: 'questions',
      name: '',
      component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
      meta: { title: '常见问题', mdfilepath: '/questions/WwoQuestions.md', aimtilelist: ['问题目录'] }
    },
    {
      path: 'charge-standard',
      name: '',
      component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
      meta: { title: '计费说明', mdfilepath: '/pricemodel/WwoPrice.md', aimtilelist: ['问题目录'] }
    }
  ]
}

export default wwoAbilityRouter
